import clsx from 'clsx'
import Image from 'components/Common/Image'
import NumberRating from 'components/Common/NumberRating'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import { getSearchTileDensityClassName } from 'components/SearchKit/SearchTiles/searchTileDensity'
import { _searchTileContainerQueryUp } from './_SearchTileBase'
import type { SearchTileLogo } from './SearchTile.types'

const Container = styled.div`
  grid-area: content-secondary;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-self: stretch;
  gap: ${rem(8)};

  &.density-compact {
    justify-content: stretch;
  }

  &.density-cro-compact {
    justify-content: stretch;
    align-items: flex-end;
    /* Pin price to the bottom when the mosaic makes the tile taller than the copy. */
    margin-top: auto;
  }
`

const RatingContainer = styled.div`
  display: none;

  ${_searchTileContainerQueryUp.tablet} {
    display: block;
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    display: none;
  }

  ${_searchTileContainerQueryUp.desktop} {
    display: block;
  }
`

const Logo = styled(Image)`
  object-fit: contain;
  margin-inline: auto;
  height: ${rem(90)};
  display: none;

  ${_searchTileContainerQueryUp.tablet} {
    display: block;
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    display: none;
  }

  ${_searchTileContainerQueryUp.desktop} {
    display: block;
  }
`

interface Props extends PropsWithChildren {
  callToAction?: ReactElement
  rating?: App.OfferRating
  logo?: SearchTileLogo
  /**
   * @default default
   */
  density?: SearchTileDensity
}

function _SearchTileContentSecondary({
  children,
  rating,
  logo,
  density = 'default',
}: Props) {
  const densityClassName = getSearchTileDensityClassName(density)

  return <Container className={clsx(_SearchTileContentSecondary.name, densityClassName)}>
    {children}
    {logo && <Logo image={logo.full} width={140} dpr={2} />}
    {rating && density !== 'cro-compact' && <RatingContainer>
      <NumberRating
        rating={rating.score}
        total={rating.reviewsTotal}
        variant="small"
        numberPosition="end"
      />
    </RatingContainer>}
  </Container>
}

export default _SearchTileContentSecondary
